module.exports = __webpack_public_path__ + "img/secondHand1.1644145c.png";